module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row item-view"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFetching),
      expression: "!isFetching"
    }],
    staticClass: "col"
  }, [_c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.item.media && _vm.item.media.length) ? _c('div', {
    staticClass: "col-2"
  }, [_c('b-carousel', {
    attrs: {
      "controls": "",
      "indicators": "",
      "background": "#ababab",
      "interval": 0,
      "img-width": "1024",
      "img-height": "480"
    }
  }, _vm._l((_vm.item.media), function(item, index) {
    return _c('b-carousel-slide', {
      key: index,
      attrs: {
        "img-src": item.url
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(_vm.item.seller) ? _c('h1', {
    staticClass: "display-3"
  }, [_vm._v(_vm._s(_vm.$t('common.item')) + " " + _vm._s(_vm.item.seller.code) + "-" + _vm._s(_vm.item.number))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('item.auctionOrderNumber')) + " " + _vm._s(_vm.item.auction_order_number))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('p', [(_vm.item.category != null) ? _c('span', [_vm._v(_vm._s(_vm.item.category.title))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('common.createdAt')) + " " + _vm._s(_vm._f("smallDate")(_vm.item.created_at)))]), _vm._v(" "), (_vm.item.tags) ? [_c('br'), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, i) {
    return _c('span', {
      staticClass: "item-tag"
    }, [_vm._v(" " + _vm._s(tag.name) + " ")])
  })] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.item.description) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('odbbarcode', {
    attrs: {
      "item": _vm.item,
      "aucdates": _vm.aucdates,
      "type": 'sticker'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('b-button-group', {
    staticClass: "pull-right"
  }, [(_vm.item.previous_id) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Vorige",
      "to": {
        name: 'item',
        mode: 'push',
        params: {
          itemId: _vm.item.previous_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.item.next_id) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Volgende",
      "to": {
        name: 'item',
        mode: 'push',
        params: {
          itemId: _vm.item.next_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-right"
  })]) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "to": {
        name: 'itemEdit'
      },
      "title": "Aanpassen",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "to": {
        name: 'itemList'
      },
      "exact": "",
      "title": "Terug",
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.item.seller) ? _c('div', {
    staticClass: "col-sm-12 col-lg-6 mb-3"
  }, [_c('b-jumbotron', {
    staticClass: " p-4 h-100"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-primary",
      "title": "Bekijk inbrenger",
      "size": "sm",
      "to": {
        name: 'auctionSeller',
        params: {
          personId: _vm.item.seller.id
        },
        query: {
          back: 'auctionSellers'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eye"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "display-4"
  }, [_vm._v("Inbrenger")]), _vm._v(" "), (_vm.item.seller) ? _c('div', [_c('person-info', {
    attrs: {
      "person": _vm.item.seller
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.item.bid != null) ? _c('div', {
    staticClass: "col-sm-12 col-lg-6 mb-3"
  }, [_c('b-jumbotron', {
    staticClass: "pt-4 px-4 pb-2 h-100"
  }, [_c('b-btn-group', {
    staticClass: "pull-right"
  }, [(_vm.item.bid.bid_number != null) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Bekijk biednummer",
      "size": "sm",
      "to": {
        name: 'auctionBuyer',
        params: {
          bidNumber: _vm.item.bid.bid_number
        },
        query: {
          back: 'auctionBuyers'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eye"
  })]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Bod aanpassen",
      "size": "sm",
      "to": {
        name: 'bidEdit',
        params: {
          bidId: _vm.item.bid.id
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1), _vm._v(" "), _c('h2', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.buyer')))]), _vm._v(" "), (_vm.item.bid.buyer) ? _c('div', [_c('person-info', {
    attrs: {
      "person": _vm.item.bid.buyer.person
    }
  })], 1) : _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('buyer.noPerson')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.item.bid.bid_number != null) ? _c('h5', [_vm._v(_vm._s(_vm.$t('bid.bidNumber')) + " " + _vm._s(_vm.item.bid.bid_number))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('bid.price')) + " "), _c('br'), _c('small', [_vm._v(_vm._s(_vm._f("smallDate")(_vm.item.bid.created_at)))])]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v("€" + _vm._s(Math.round(_vm.item.bid.price)))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col mb-3"
  }, [_c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('h2', {
    staticClass: "display-4 mb-4"
  }, [_vm._v(_vm._s(_vm.$t('common.financial')))]), _vm._v(" "), (_vm.item.target_price_1) ? _c('div', [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('item.targetprice', {
    number: 1
  })))]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v("€ " + _vm._s(Math.round(_vm.item.target_price_1)))])]) : _vm._e(), _vm._v(" "), (_vm.item.target_price_1) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('item.targetprice', {
    number: 2
  })))]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v("€ " + _vm._s(Math.round(_vm.item.target_price_2)))])]) : _vm._e(), _vm._v(" "), (_vm.item.limit) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('item.limit')))]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v("€ " + _vm._s(Math.round(_vm.item.limit)))])]) : _vm._e(), _vm._v(" "), (_vm.item.commission) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('item.commission')))]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v("€ " + _vm._s(Math.round(_vm.item.commission)))])]) : _vm._e(), _vm._v(" "), (_vm.item.commission_percentage) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('item.commisionPercentage')))]), _vm._v(" "), _c('h3', {
    staticClass: "display-4 text-right"
  }, [_vm._v(_vm._s(_vm.item.commission_percentage) + "%")])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-xl-6 mb-3"
  }, [_c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('b-form-group', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": _vm.$t('pendingBid.add'),
      "exact": "",
      "to": {
        name: 'pendingBidAdd',
        query: {
          back: 'item'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })])], 1), _vm._v(" "), _c('h2', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.pendingBids')))]), _vm._v(" "), _c('pending-bids')], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab2db386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/Item.vue
// module id = 1335
// module chunks = 1